import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'app/providers/Store';
import { IStore } from 'app/providers/Store/model/store';
import { UserRequestDto, keycloak } from 'shared/api';
import { createUser } from 'entities/user/model/actions';
import { useGlobalSpinner } from 'shared/hooks';
import { RegistrationForm } from '../components';
import styles from './RegistrationPage.module.scss';

export const RegistrationPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state: IStore) => state.userSlice.isLoading);
  const { showSpinner, hideSpinner } = useGlobalSpinner();

  const handleSubmit = async (data: UserRequestDto) => {
    try {
      showSpinner('Регистрация пользователя...');

      // Получаем keycloakUserId из текущего пользователя
      const keycloakUserId = keycloak.tokenParsed?.sub;

      if (!keycloakUserId) {
        console.error('Keycloak user ID не найден');
        return;
      }

      // Создаем пользователя с данными из формы
      const userData: UserRequestDto = {
        ...data,
        keycloakUserId,
      };

      await dispatch(createUser(userData)).unwrap();

      // После успешной регистрации перенаправляем на главную
      navigate('/');
    } catch (error) {
      console.error('Ошибка при регистрации:', error);
    } finally {
      hideSpinner();
    }
  };

  const handleCancel = () => {
    // Полный разлогин в Keycloak
    keycloak.logout();
  };

  return (
    <div className={styles.registrationPage}>
      <RegistrationForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={isLoading}
      />
    </div>
  );
};
